<template>
  <BannerLayout bg-color="primary-dark">
    <template #text>
      <div class="flex items-center flex-wrap gap-1.5">
        <p class="font-semibold">
          {{ directConsultations.length + scheduledConsultations.length }}
          {{ t('Consultation requests are open') }}:
        </p>
        <DirectConsultationTypeChip
          v-for="item in directConsultationsOverview"
          :key="item.urgency"
          :consultation-type="item.urgency"
          :count="item.count"
          variant="outlined"
          dark
        />

        <ScheduledConsultationChip
          v-if="scheduledConsultations.length"
          :count="scheduledConsultations.length"
        />
      </div>
    </template>
    <template #actions>
      <div class="flex flex-wrap-reverse gap-2 max-sm:w-full">
        <VBtn
          data-testid="consultations-overview-button"
          class="button-large max-sm:flex-1"
          color="primary"
          :to="{ name: routeNames.CONSULTATIONS }"
          :active="false"
        >
          {{ t('Open consultation overview') }}
        </VBtn>
      </div>
    </template>
  </BannerLayout>
</template>

<script setup lang="ts">
import DirectConsultationTypeChip from '@/atoms/DirectConsultationTypeChip.vue'
import { UrgencyDTO, type ConsultationRequestDTO, type ScheduledConsultationDTO } from '@/generated'

import BannerLayout from '@/atoms/BannerLayout.vue'

import { useI18n } from 'vue-i18n'
import { routeNames } from '@/router/routeNames'
import { computed } from 'vue'
import ScheduledConsultationChip from '@/components/consultationrequest/ScheduledConsultationChip.vue'

interface Props {
  directConsultations: ConsultationRequestDTO[]
  scheduledConsultations: ScheduledConsultationDTO[]
}

const { t } = useI18n()

const { directConsultations } = defineProps<Props>()

const directConsultationsOverview = computed(() =>
  [UrgencyDTO.EMERGENCY, UrgencyDTO.URGENT, UrgencyDTO.ROUTINE]
    .map((consultationType) => ({
      urgency: consultationType,
      count: directConsultations.filter(({ urgency }) => urgency === consultationType).length
    }))
    .filter(({ count }) => count > 0)
)
</script>
